var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 32,
  viewBox: "0 0 20 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#05cd78",
  fillRule: "evenodd",
  d: "M20 3.692 16.25 0 0 16l16.25 16L20 28.308 7.5 16z"
})));
export default SvgArrow;